module.exports = __webpack_public_path__ + "img/5.e82dc64c.png";